import Vue from 'vue'
import moment from 'moment';

// state
export const state = {
    procedures: [],
    proceduresLoaded: false,

    expenseCategories: [],
    expenseCategoriesLoaded: false,

    tests: [],
    testsLoaded: false,

    drugs: [],
    drugsLoaded: false,

    drugGroups: [],
    drugGroupsLoaded: false,

    reports: null,
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    type: "summary",
}

// getters
export const getters = {
    expenseCategories: state => state.expenseCategories,
    procedures: state => state.procedures,
    tests: state => state.tests,
    drugs: state => state.drugs,
    drugGroups: state => state.drugGroups,
    reports: state => state.reports
}

// mutations
export const mutations = {
    setExpenseCategories: (state, expenseCategories) => {
        state.expenseCategories = expenseCategories;
        state.expenseCategoriesLoaded = true;
    },
    setProcedures: (state, procedures) => {
        state.procedures = procedures;
        state.proceduresLoaded = true;
    },
    setTests: (state, tests) => {
        state.tests = tests;
        state.testsLoaded = true;
    },
    setDrugs: (state, drugs) => {
        state.drugs = drugs;
        state.drugsLoaded = true;
    },
    setDrugGroups: (state, drugGroups) => {
        state.drugGroups = drugGroups;
        state.drugGroupsLoaded = true;
    },

    setReports: (state, reports) => {
        state.reports = reports
    },

    setStartDate(state, date) {
        state.startDate = date;
    },

    setEndDate(state, date) {
        state.endDate = date;
    },

    setType(state, type) {
        state.type = type;
    }
}

// actions
export const actions = {
    loadExpenseCategories({ commit, state }, force = false) {

        if (force || !state.expenseCategoriesLoaded) {
            Vue.axios.get('/api/expense_categories').then((resp) => {
                commit('setExpenseCategories', resp.data)
            }).catch((err) => {
                Vue.$snackbar.error('Could not get expense categories.')
            });
        }

    },

    loadProcedures({ commit, state }, force = false) {

        if (force || !state.proceduresLoaded) {
            Vue.axios.get('/api/procedures').then((resp) => {
                commit('setProcedures', resp.data)
            }).catch((err) => {
                Vue.$snackbar.error('Could not get procedures.')
            });
        }

    },

    loadTests({ commit, state }, force = false) {

        if (force || !state.testsLoaded) {
            Vue.axios.get('/api/tests').then((resp) => {
                commit('setTests', resp.data)
            }).catch((err) => {
                Vue.$snackbar.error('Could not get tests.')
            });
        }

    },

    loadDrugs({ commit, state }, force = false) {

        if (force || !state.drugsLoaded) {
            Vue.axios.get('/api/drugs').then((resp) => {
                commit('setDrugs', resp.data)
            }).catch((err) => {
                Vue.$snackbar.error('Could not get drugs.')
            });
        }

    },

    loadDrugGroups({ commit, state }, force = false) {

        if (force || !state.drugGroupsLoaded) {
            Vue.axios.get('/api/drug_groups').then((resp) => {
                commit('setDrugGroups', resp.data)
            }).catch((err) => {
                Vue.$snackbar.error('Could not get drug groups.')
            });
        }

    }


}